import { Autocomplete } from "@/components/atoms";
import { AutocompleteOption } from "@/components/atoms/Autocomplete";
import { useHcDomainList } from "@/hooks";
import { HealthcareDomain } from "@/types/core";
import { UserHealthcareDomain } from "@/types/user";
import { useEffect, useRef } from "react";

export interface UserHealthcareDomainDropdownProps {
  userDomains: UserHealthcareDomain[];
  selectedHealthcareDomains: HealthcareDomain[];
  setSelectedHealthcareDomains: (
    selectedHealthcareDomains: HealthcareDomain[],
  ) => void;
}

export const UserHealthcareDomainDropdown = ({
  userDomains,
  selectedHealthcareDomains,
  setSelectedHealthcareDomains,
}: UserHealthcareDomainDropdownProps) => {
  const { domains, loading: domainsLoading } = useHcDomainList();

  const hasInitialized = useRef(false);

  // Initialize selected domains from userDomains only once
  useEffect(() => {
    if (
      !hasInitialized.current &&
      !selectedHealthcareDomains?.length &&
      userDomains?.length
    ) {
      const domainsFromUser = userDomains.map(ud => ud.healthcare_domain);
      setSelectedHealthcareDomains(domainsFromUser);
      hasInitialized.current = true;
    }
  }, [userDomains, selectedHealthcareDomains, setSelectedHealthcareDomains]);

  const options: AutocompleteOption[] =
    domains?.map(domain => ({
      key: domain.id,
      value: domain.value,
    })) || [];

  const selectedOptions: AutocompleteOption[] =
    selectedHealthcareDomains?.map(domain => ({
      key: domain.id,
      value: domain.value,
    })) || [];

  return (
    <Autocomplete
      componentName={"healthcare-domains"}
      multiple
      inputLabel="Healthcare Domains"
      options={options}
      value={selectedOptions}
      onChange={(_, value) => {
        const selectedValues = (value as AutocompleteOption[]).filter(Boolean);

        const selected = domains?.filter(domain =>
          selectedValues.some(el => el.key === domain.id),
        );
        if (selected) {
          setSelectedHealthcareDomains(selected);
        }
      }}
      loading={domainsLoading}
      disableClearable
      renderCheckMarks
    />
  );
};
